import { SignInFormValue } from '../../models/sign-in-form/sign-in-form-value.type';

export const mockSignInFormValue: SignInFormValue = {
  email: 'email@test.com',
  password: 'Password123',
};
